<template>
    <div style="width: 100%;height: calc(100vh - 300px)">
        <iframe style="border: none" width="100%" height="96%" :src="url"></iframe>
    </div>
</template>

<script>
    export default {
        name: "index",
        data(){
            return{
                url:window.BASE_CONFIG.USER_WEB+'user-manage?token='+this.$store.state.user.token
            }
        }
    }
</script>

<style scoped>

</style>